/**
 * Zobrazí "slevovou cenu" u produktů, které mají nastavený Seals Subscriptions plán,
 * pokud je tahle cena nižší než aktuálně zobrazená cena (reálná Shopify sleva má přednost,
 * pokud je výhodnější). Funguje na jakémkoliv výpisu produktů (kolekce, "elementy",
 * widget podobných produktů) - hledá karty <product-grid-item data-item-id="...">
 * a přepisuje jejich cenu + compare-at stejnými CSS třídami, jaké theme používá pro
 * reálnou slevu. Badge "Akce" se NEpřidává - ten zůstává jen pro skutečnou Shopify slevu.
 *
 * Data bere z backendu: GET https://shopify.pholub.cz/ramissio/subscriptions/planPrices?ids=...
 * (cache naplněná cronem, žádné volání na Seals API za běhu stránky).
 *
 * Nasazení: vlož jako theme asset (assets/subscription-sale-price.js) a přidej do
 * layout/theme.liquid před </body>:
 *   {{ 'subscription-sale-price.js' | asset_url | script_tag }}
 * nebo obsah vlož přímo do <script> tagu v šabloně.
 */
(function () {
    'use strict';

    var API_URL = 'https://shopify.pholub.cz/ramissio/subscriptions/planPrices';

    var checked = new WeakSet();   // karty, pro které už proběhl fetch (aby se nevolalo opakovaně)
    var styled = new WeakSet();    // karty, které už mají vloženou slevu

    // Rozpozná, jestli poslední oddělovač (. nebo ,) v čísle je desetinná čárka/tečka,
    // nebo jen oddělovač tisíců (např. "1,250" = 1250, ne 1.25). Pravidlo: desetinný
    // oddělovač má za sebou 1-2 číslice, oddělovač tisíců jich má vždy přesně 3.
    function analyzeNumberFormat(numPart) {
        var separators = numPart.match(/[.,]/g) || [];
        if (!separators.length) {
            return { hasDecimal: false, decimalSep: null, groupSep: null };
        }

        var lastSepChar = separators[separators.length - 1];
        var lastSepIndex = numPart.lastIndexOf(lastSepChar);
        var digitsAfterLastSep = numPart.length - lastSepIndex - 1;
        var hasDecimal = digitsAfterLastSep >= 1 && digitsAfterLastSep <= 2;

        return {
            hasDecimal: hasDecimal,
            decimalSep: hasDecimal ? lastSepChar : null,
            decimalIndex: hasDecimal ? lastSepIndex : null,
            groupSep: hasDecimal ? null : lastSepChar,
        };
    }

    function parsePrice(text) {
        var numPart = String(text).replace(/[^\d.,]/g, '');
        var info = analyzeNumberFormat(numPart);

        if (!info.hasDecimal) {
            return parseFloat(numPart.replace(/[.,]/g, ''));
        }

        var intPart = numPart.slice(0, info.decimalIndex).replace(/[.,]/g, '');
        var decPart = numPart.slice(info.decimalIndex + 1);

        return parseFloat(intPart + '.' + decPart);
    }

    function groupThousands(intStr, groupChar) {
        return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, groupChar);
    }

    // Nahradí jen číselnou část v původním textu (zachová měnu, mezery, pořadí,
    // desetinný/tisícový oddělovač a to, jestli měl původní text desetiny vůbec).
    function formatPriceLike(originalText, newAmount) {
        // Číselné jádro musí ZAČÍNAT i KONČIT číslicí, takže mezery kolem něj
        // (např. "1,250 Kč" -> mezera před "Kč") zůstanou správně v prefixu/suffixu.
        var match = String(originalText).match(/^(\D*)(\d[\d.,\s]*\d|\d)(\D*)$/);
        if (!match) {
            return originalText;
        }

        var prefix = match[1];
        var numPart = match[2];
        var suffix = match[3];
        var info = analyzeNumberFormat(numPart);

        var formatted;
        if (info.hasDecimal) {
            formatted = newAmount.toFixed(2).replace('.', info.decimalSep);
        } else {
            var rounded = String(Math.round(newAmount));
            formatted = info.groupSep ? groupThousands(rounded, info.groupSep) : rounded;
        }

        return prefix + formatted + suffix;
    }

    // Seals plány typu PRICE/FIXED_AMOUNT jsou vždy v základní měně obchodu (CZK),
    // ne v měně, kterou zrovna vidí návštěvník (Shopify Markets - EUR/HUF/RON...).
    // Shopify.currency.rate je přepočet ze základní měny do aktuálně zobrazené.
    function getCurrencyRate() {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
            var rate = parseFloat(window.Shopify.currency.rate);
            if (isFinite(rate) && rate > 0) {
                return rate;
            }
        }
        return 1; // jednoměnový obchod / konverze není dostupná - beze změny
    }

    function computeCandidatePrice(plan, currentAmount, currencyRate) {
        if (plan.type === 'PRICE') {
            return plan.value * currencyRate;
        }
        if (plan.type === 'PERCENTAGE') {
            // Procenta se počítají z aktuálně zobrazené ceny - měna už sedí, přepočet netřeba.
            return currentAmount * (1 - plan.value / 100);
        }
        if (plan.type === 'FIXED_AMOUNT') {
            return currentAmount - (plan.value * currencyRate);
        }
        return null;
    }

    function applyDiscount(card, plan) {
        if (styled.has(card)) {
            return;
        }

        var priceBlock = card.querySelector('.product__grid__price');
        var priceEl = priceBlock ? priceBlock.querySelector('.price') : null;
        if (!priceEl) {
            return;
        }

        var currentText = priceEl.textContent.trim();
        var currentAmount = parsePrice(currentText);
        if (!isFinite(currentAmount) || currentAmount <= 0) {
            return;
        }

        var candidate = computeCandidatePrice(plan, currentAmount, getCurrencyRate());
        if (candidate === null || !isFinite(candidate) || candidate <= 0 || candidate >= currentAmount) {
            return; // předplatné není ve skutečnosti levnější - necháme DOM beze změny
        }

        styled.add(card);

        var compareEl = priceBlock.querySelector('.compare-at');
        if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'compare-at';
            priceBlock.appendChild(compareEl);
        }
        compareEl.textContent = currentText;

        priceEl.textContent = formatPriceLike(currentText, candidate);
        priceEl.classList.add('on-sale');

        var contentEl = card.querySelector('.product-grid-item__content') || card;
        contentEl.classList.add('on-sale');

        // Badge "Akce" se záměrně NEpřidává - ten zůstává vyhrazený jen pro
        // skutečnou Shopify slevu (compare_at_price), ne pro cenu v předplatném.
    }

    function collectCards(root) {
        var scope = root && root.querySelectorAll ? root : document;
        return Array.prototype.slice.call(scope.querySelectorAll('product-grid-item[data-item-id]'));
    }

    function run(root) {
        var cards = collectCards(root).filter(function (card) {
            return !checked.has(card);
        });

        if (!cards.length) {
            return;
        }

        cards.forEach(function (card) {
            checked.add(card);
        });

        var ids = [];
        cards.forEach(function (card) {
            var id = card.dataset.itemId;
            if (id && ids.indexOf(id) === -1) {
                ids.push(id);
            }
        });

        if (!ids.length) {
            return;
        }

        fetch(API_URL + '?ids=' + ids.join(','), {
            headers: { Accept: 'application/json' }
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                if (!data || !data.success || !data.plans) {
                    return;
                }
                cards.forEach(function (card) {
                    var plan = data.plans[card.dataset.itemId];
                    if (plan) {
                        applyDiscount(card, plan);
                    }
                });
            })
            .catch(function () {
                // Selhání dotažení cen nesmí rozbít stránku - reálné ceny zůstanou beze změny.
            });
    }

    function init() {
        run(document);

        // Widget podobných produktů se vykresluje přes Shopify Section Rendering API po tomto eventu.
        document.addEventListener('theme:related-products:added', function (event) {
            run(event.target || document);
        });

        // Záchytný mechanismus pro jakýkoliv jiný AJAX výpis (filtrování, stránkování, quick view, ...).
        var debounceTimer = null;
        var observer = new MutationObserver(function (mutations) {
            var hasNewCards = mutations.some(function (mutation) {
                return Array.prototype.some.call(mutation.addedNodes, function (node) {
                    return node.nodeType === 1 && (
                        (node.matches && node.matches('product-grid-item')) ||
                        (node.querySelector && node.querySelector('product-grid-item'))
                    );
                });
            });

            if (!hasNewCards) {
                return;
            }

            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                run(document);
            }, 150);
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
